import { render, staticRenderFns } from "./NormalSearchNav589.vue?vue&type=template&id=478fa0fd&scoped=true"
import script from "./NormalSearchNav589.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav589.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478fa0fd",
  null
  
)

export default component.exports